import React from 'react';

export default function Spacer(props){
    return (
        <div style={{paddingTop:props.size}}/>
    );
}